// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"99977197301b6054db64","532":"4c56d33134195756d6e4","691":"e3fd8861de21474608e9"}[chunkId] + ".js";
};